export default __webpack_public_path__ + "static/media/CRChurchillOpen.920ba950.jpg";